/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { SyncRepoFragmentDoc } from "./queries.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SyncRepoByIdQueryVariables = Types.Exact<{
  syncRepositoryId: Types.Scalars["SyncRepositoryId"];
}>;

export type SyncRepoByIdQuery = {
  readonly __typename: "Query";
  readonly syncRepositoryById: {
    readonly __typename: "SyncRepository";
    readonly id: c.SyncRepositoryId;
    readonly repoName: string;
    readonly repoId: number | null;
    readonly repoOwner: string;
    readonly mainBranch: string;
    readonly requirePullRequests: boolean;
    readonly description: string | null;
    readonly vcsConnectionType: Types.VcsConnectionType;
    readonly grants: ReadonlyArray<{
      readonly __typename: "SharedAssetGrant";
      readonly id: string;
      readonly role: Types.SharedAssetRole;
      readonly holder:
        | {
            readonly __typename: "Group";
            readonly name: string;
            readonly groupId: c.GroupId;
          }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly name: string;
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          };
    }>;
  };
};

export const SyncRepoByIdDocument = gql`
  query SyncRepoById($syncRepositoryId: SyncRepositoryId!) {
    syncRepositoryById(syncRepositoryId: $syncRepositoryId) {
      ...SyncRepoFragment
    }
  }
  ${SyncRepoFragmentDoc}
`;

/**
 * __useSyncRepoByIdQuery__
 *
 * To run a query within a React component, call `useSyncRepoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncRepoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncRepoByIdQuery({
 *   variables: {
 *      syncRepositoryId: // value for 'syncRepositoryId'
 *   },
 * });
 */
export function useSyncRepoByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    SyncRepoByIdQuery,
    SyncRepoByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SyncRepoByIdQuery, SyncRepoByIdQueryVariables>(
    SyncRepoByIdDocument,
    options,
  );
}
export function useSyncRepoByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SyncRepoByIdQuery,
    SyncRepoByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SyncRepoByIdQuery, SyncRepoByIdQueryVariables>(
    SyncRepoByIdDocument,
    options,
  );
}
export type SyncRepoByIdQueryHookResult = ReturnType<
  typeof useSyncRepoByIdQuery
>;
export type SyncRepoByIdLazyQueryHookResult = ReturnType<
  typeof useSyncRepoByIdLazyQuery
>;
export type SyncRepoByIdQueryResult = Apollo.QueryResult<
  SyncRepoByIdQuery,
  SyncRepoByIdQueryVariables
>;
